import React from 'react';
import './client info.css'
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { deleteApi, getClientHistoryApi, lockClientApi, onProgressApi, updateStatusApi } from './clientInfoApi';
import { ActionCardContent, MainCardContent, ModalForUpdateStatus } from './clientInfoDesign';
class clientInfo extends React.Component {
  state = {
    actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
    page: 1,
    pages: 1,
    id: this.props.location.state.data.id,
    clientName: this.props.location.state.data.clientName ? this.props.location.state.data.clientName : '',
    clientPhone: this.props.location.state.data.clientPhone ? this.props.location.state.data.clientPhone : '',
    clientCountry: this.props.location.state.data.clientCountry ? this.props.location.state.data.clientCountry.countryName : null,
    createdAt: this.props.location.state.data.createdAt,
    city: this.props.location.state.data.city ? this.props.location.state.data.city.cityName : null,
    area: this.props.location.state.data.area ? this.props.location.state.data.area.areaName : null,
    category: this.props.location.state.data.category ? this.props.location.state.data.category.categoryName : null,
    subCategory: this.props.location.state.data.subCategory ? this.props.location.state.data.subCategory.categoryName : null,
    contractType: this.props.location.state.data.contractType,
    status: this.props.location.state.data.status,
    user: this.props.location.state.data.user,
    notes: this.props.location.state.data.notes ? this.props.location.state.data.notes : "",
    commission: this.props.location.state.data.commission,
    statusReason: this.props.location.state.data.statusReason,
    clientType: this.props.location.state.data.clientType ? this.props.location.state.data.clientType : '',
    clientStatus: this.props.location.state.data.clientStatus ? this.props.location.state.data.clientStatus : '',
    followUpStatus: this.props.location.state.data.followUpStatus ? this.props.location.state.data.followUpStatus : null,
    isLocked: this.props.location.state.data.isLocked ? this.props.location.state.data.isLocked : false,
    modal: false,
    cities: [],
    areas: [],
    categories: [],
    subCategories: [],
    clientHistory: [],
    projects: [],
    currentProject: null,
  };

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidMount() {
    this.getClientData()
    this.getClientHistory(this.state.id)
    this.getCategory()
    this.getCities(1)
    this.getProjects()
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getClientData = () => {
    axios.get(`${BASE_END_POINT}clients/${this.state.id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      }
    })
      .then(response => {
        console.log('client  ', response.data.data)
        this.setState({
          loading: false,
          clientName: response.data.data.clientName,
          clientPhone: response.data.data.clientPhone,
          clientCountry: response.data.data.clientCountry ? response.data.data.clientCountry.countryName : null,
          clientStatus: response.data.data.clientStatus ? response.data.data.clientStatus : '',
          clientType: response.data.data.clientType ? response.data.data.clientType : '',
          createdAt: response.data.data.createdAt,
          user: response.data.data.user,
          notes: response.data.data.notes ? response.data.data.notes : "",
          contractType: response.data.data.contractType,
          status: response.data.data.status,
          commission: response.data.data.commission,
          priceFrom: response.data.data.priceFrom,
          priceTo: response.data.data.priceTo,
          city: response.data.data.city ? response.data.data.city.cityName : null,
          area: response.data.data.area ? response.data.data.area.areaName : null,
          category: response.data.data.category ? response.data.data.category.categoryName : null,
          subCategory: response.data.data.subCategory ? response.data.data.subCategory.categoryName : null,
          statusReason: response.data.data.statusReason ? response.data.data.statusReason : " ",
        })
        //this.getCountry(response.data.data.clientCountry ? response.data.data.clientCountry.id : 0)
      })
      .catch(error => {
        console.log('theClient ERROR  ', error)
        console.log('theClient ERROR  ', error.respose)
      })
  }
  getProjects = () => {
    axios.get(`${BASE_END_POINT}projects/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ projects: response.data.data })
      })
      .catch(error => {
        console.log("ALL projects ERROR")
        console.log(error.response)
      })
  }
  getCities = (country) => {
    axios.get(`${BASE_END_POINT}countries/1/cities/withoutPagenation/get?country=${country}`)
      .then(response => {
        console.log('cities  ', response.data)
        this.setState({ cities: response.data.data })
      })
      .catch(error => {
        console.log('cities ERROR  ', error)
        console.log('cities ERROR  ', error.respose)
      })
  }
  getAreas = (city) => {
    axios.get(`${BASE_END_POINT}areas/${city}/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ areas: response.data.data })
      })
      .catch(error => {
        console.log("ALL areas ERROR")
        console.log(error.response)
      })
  }
  getCategory = () => {
    axios.get(`${BASE_END_POINT}categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ categories: response.data.data })
      })
      .catch(error => {
        console.log("ALL categories ERROR")
        console.log(error.response)
      })
  }
  getSubCategory = (category) => {
    axios.get(`${BASE_END_POINT}categories/${category}/sub-categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ subCategories: response.data.data })
      })
      .catch(error => {
        console.log("ALL subCategories ERROR")
        console.log(error.response)
      })
  }
  onProgress = async () => {
    try {
      await onProgressApi(this.props.location.state.data.id, this.props.currentUser.token, this.props.isRTL, allStrings);
      console.log("client ON PROGRESS");
      this.props.history.goBack();
    } catch (error) {
      console.log("on progress ", error);
    }
  };
  lockClient = async () => {
    try {
      await lockClientApi(this.props.location.state.data.id, this.props.currentUser.token, this.props.isRTL, allStrings);
      console.log("client LOCKED");
      this.props.history.goBack();
    } catch (error) {
      console.log("lock client ", error);
    }
  };
  getClientHistory = async (id) => {
    try {
      const data = await getClientHistoryApi(id, this.props.currentUser.token, this.props.isRTL);
      this.setState({ clientHistory: data.data });
    } catch (error) {
      console.log('get client History ERROR ', error);
    }
  };
  delete = async () => {
    try {
      await deleteApi(this.props.location.state.data.id, this.props.currentUser.token, this.props.isRTL, allStrings);
      console.log("request DELETED");
      this.props.history.goBack();
    } catch (error) {
      console.log("delete ", error);
    }
  };
  updateStatus = async () => {
    const { clientType, clientStatus, notes, id } = this.state;
    if (hasValue(notes) && clientType != null && clientStatus != null) {
      try {
        let response = await updateStatusApi(id, this.state, this.props.currentUser.token, this.props.isRTL, allStrings);
        if (response.success) {
          this.getClientHistory(id)
          this.setState({ modal: false })
        }

      } catch (error) {
        console.log("update status ", error);
      }
    }
  };
  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  handleChangeState = (fieldName, value) => {
    console.log(fieldName, value)
    this.setState({ [fieldName]: value });
  };
  submitHandler = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.updateStatus()
  };
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  }

  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('CLIENTS')) return <Redirect to='/Home' />
    console.log('the state ', this.state)
    return (
      <div className="App">
        <MDBContainer>
          <ModalForUpdateStatus
            isOpen={this.state.modal}
            toggle={this.toggle}
            submitHandler={this.submitHandler}
            changeHandler={this.changeHandler}
            state={this.state}
            isRTL={this.props.isRTL}
            allStrings={allStrings}
            getAreas={this.getAreas}
            getSubCategory={this.getSubCategory}
            handleChangeState={this.handleChangeState}
          />
          <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
            <MDBCol lg="5" md='12'>
              <div className="infoCard">
                <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                  <CardMedia style={{ height: "0px" }} />
                  <CardHeader></CardHeader>
                  <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                    <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                      <span class="material-icons" style={{ color: 'white', fontSize: 20 }}>featured_video</span>
                    </div>
                    <div className="tableTitle" style={{ display: 'inline-block', marginTop: '-60px', marginLeft: '0', marginRight: '0' }}>
                      <p></p>
                    </div>
                  </div>
                  <MainCardContent
                    state={this.state}
                    isRTL={this.props.isRTL}
                    allStrings={allStrings}
                    history={this.props.history}
                    currentUser={this.props.currentUser}
                    toggle={this.toggle}
                    deleteRequest={this.delete}
                    onProgress={this.onProgress}
                    lockClient={this.lockClient}
                  />
                </Card>
              </div>
            </MDBCol>
            <ActionCardContent
              state={this.state}
              isRTL={this.props.isRTL}
              allStrings={allStrings}
              history={this.props.history}
            />
          </MDBRow>
        </MDBContainer>

      </div>
    )
  }
}


const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(clientInfo)
);